import React from 'react'
import { BaseView } from '@/components/base'
import {
  SendAmountDisplay,
  SendConversionRate,
  SendCurrencySelector,
  SendNumberPad,
} from '@/features/send-money'

export const SendContent: React.FC = () => {
  return (
    <BaseView
      className="flex-1 flex flex-col overflow-hidden"
      data-component="send-unified-content"
    >
      {/* Центральная область - ограничиваем размер */}
      <BaseView
        justify="center"
        align="center"
        className="gap-4 overflow-hidden flex-shrink-0" // Убрал flexGrow, добавил flex-shrink-0
        style={{
          paddingTop: 12,
          paddingBottom: 12,
        }}
      >
        <BaseView className="gap-3" center>
          <SendAmountDisplay />
          <SendConversionRate />
        </BaseView>
        <SendCurrencySelector />
      </BaseView>

      {/* Нижняя область - теперь она получит всё оставшееся место */}
      <BaseView
        data-component="send-content-wrapper"
        className="flex-1 flex flex-col justify-between gap-2" // flex-1 теперь растянет эту область
        // style={{
        //   paddingBottom: 80,
        // }}
      >
        <SendNumberPad />
      </BaseView>
    </BaseView>
  )
}
